import React from 'react';
import Page from "../component/Page/Page";
import BizStepForm from './BizStepForm';


class BizStepFormPage extends React.Component {
  render() {
    const {match, history} = this.props;
    return (
        <Page title="Dados da Etapa">
          <BizStepForm match={match} history={history}/>
        </Page>
    );
  }
}

export default BizStepFormPage;



// WEBPACK FOOTER //
// ./src/bizStep/BizStepFormPage.js